import { makeStyles } from '@mui/styles'
import {
  AQUA_GREEN,
  EERIE_BLACK,
  LIGHT_GRAY,
  SIDEBAR_SILVER,
  WHITE,
} from '@returnmates/client-core/src/constants/colors'
import { URBANIST } from '@returnmates/ui-core/src/constants/styles/fonts'

const useStyles = makeStyles(() => ({
  header: {
    position: 'sticky',
    top: 0,
    width: '100%',
    height: 115,
    padding: 20,
    backgroundColor: AQUA_GREEN,
    transition: 'all 0.3s',
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 15,

    '& > svg': {
      marginRight: 10,
    },
  },
  title: {
    fontFamily: URBANIST,
    fontWeight: 700,
    fontSize: 18,
    lineHeight: '120%',
    color: LIGHT_GRAY,
  },
  entityIdContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: 20,
  },
  entityId: {
    fontFamily: URBANIST,
    fontWeight: 700,
    fontSize: 14,
    lineHeight: '140%',
    color: EERIE_BLACK,
    letterSpacing: 0.2,
  },
  copyIcon: {
    cursor: 'pointer',
  },
  content: {
    padding: '10px 10px 80px',
    overflowY: 'auto',
    overflowX: 'hidden',
    height: 'calc(100vh - 110px)',
    background: WHITE,
  },
  closeIcon: {
    position: 'absolute',
    left: -11.5,
    top: 75,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 23,
    height: 23,
    borderRadius: '50%',
    backgroundColor: SIDEBAR_SILVER,
    cursor: 'pointer',
  },
}))

export default useStyles
